
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbRelatorioUnidades extends AppService {
  abstract getRelatorioUnidades(filter: String): Observable<any>;
  abstract getRelatorioCompleto(filter: String): Observable<any>;
  abstract getRelatorio(filter: string): Observable<any>;
}